/**
 * Which slice of the ridgewill.com sky the page band shows.
 *
 * The site's home page plays a day-long sky that opens on the visitor's own
 * hour, and every other ridgewill.com surface carries a band of the same sky
 * at that hour. These are its four stills, copied from RidgeWill/ridgewill-site
 * (assets/home/sky-*) into public/sky so the portal needs no second origin for
 * them. The hour boundaries are the site's own (mockups/tie-in/chrome.js).
 *
 * Read once, at load: a band that changed photograph while somebody was
 * filling in a form would be movement nobody asked for.
 */
export type SkyPart = 'dawn' | 'midday' | 'sunset' | 'night';

export function skyPartAt(date: Date): SkyPart {
  const h = date.getHours();
  if (h >= 5 && h < 10) return 'dawn';
  if (h >= 10 && h < 17) return 'midday';
  if (h >= 17 && h < 20) return 'sunset';
  return 'night';
}

export function skyImageAt(date: Date): string {
  const part = skyPartAt(date);
  return part === 'dawn' ? '/sky/dawn.jpg' : `/sky/${part}.webp`;
}
